export function optional(f) {
  return f == null ? null : required(f);
}

export function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-hierarchy/src/accessors.js
// module id = ../../../../d3-hierarchy/src/accessors.js
// module chunks = 3